@if (parentFormGroup.controls[controlName]) {
  <mat-form-field
    [formGroup]="parentFormGroup"
    appearance="fill"
    class="form-field w-full"
    floatLabel="always"
    hideRequiredMarker
    >
    @if (label) {
      <mat-label
        [class.error]="error"
        class="label"
        >
        {{ label }}
        @if (isRequired) {
          <span>*&nbsp;</span>
          }:
        @if (labelBadge) { <span class="field-label-badge" data-testid="field-label-badge">{{ labelBadge }}</span> }
      </mat-label>
      }
      @if (prefixIcon) {
        <mat-icon
          class="prefix"
          matPrefix
          svgIcon="{{prefixIcon}}"
          />
      }
      @if (suffixIcon) {
        <mat-icon
          class="suffix"
          matSuffix
          svgIcon="{{suffixIcon}}"
          />
      }
      @if (warning || suffixText) {
        <div class="suffix flex justify-end items-center" matSuffix>
          @if (error) {
            <mat-icon
              class="suffix"
              svgIcon="error"
              />
          }
          @if (!error && warning) {
            <mat-icon
              class="suffix"
              svgIcon="warning"
              />
          }
          @if (suffixText) {
            <div
              class="suffix uppercase"
              >
              {{ suffixText }}
            </div>
          }
        </div>
      }
      <input
        #input
        [appCurrencyInput]="showCurrency"
        [decimal]="isDecimalAllowed"
        [errorStateMatcher]="matcher"
        [decimalPlaces]="decimalPlaces"
        [formControlName]="controlName"
        [max]="max"
        [maxlength]="maxLength"
        [min]="min"
        class="input number-input"
        matInput
        onlyDigits
        placeholder="{{placeholder}}"
        type="text"
        >
      @if (error) {
        <mat-error>{{ error }}</mat-error>
      }
      @if (!error && warning) {
        <mat-hint class="text-type-14 warning">{{ warning }}</mat-hint>
      }
      @if (!error && !warning && hint) {
        <mat-hint class="text-type-14">{{ hint }}</mat-hint>
      }
    </mat-form-field>
  }

